import { c as _c } from "react/compiler-runtime";
import React from "react";
import type { ApiDrop } from "@/generated/models/ApiDrop";
import type { ApiDropPart } from "@/generated/models/ApiDropPart";
import type { ApiDropMentionedUser } from "@/generated/models/ApiDropMentionedUser";
import type { ApiDropGroupMention } from "@/generated/models/ApiDropGroupMention";
import type { ApiMentionedWave } from "@/generated/models/ApiMentionedWave";
import WaveDropPartTitle from "./WaveDropPartTitle";
import WaveDropPartContent from "./WaveDropPartContent";
import { ImageScale } from "@/helpers/image.helpers";
import type { DropContentPresentation } from "./dropContentPresentation";
interface WaveDropPartDropProps {
  drop: ApiDrop;
  activePart: ApiDropPart;
  havePreviousPart: boolean;
  haveNextPart: boolean;
  isStorm: boolean;
  activePartIndex: number;
  setActivePartIndex: (index: number) => void;
  onQuoteClick: (drop: ApiDrop) => void;
  isEditing?: boolean | undefined;
  isSaving?: boolean | undefined;
  readonly onSave?: ((newContent: string, mentions?: ApiDropMentionedUser[], mentionedGroups?: ApiDropGroupMention[], mentionedWaves?: ApiMentionedWave[]) => void) | undefined;
  readonly onCancel?: (() => void) | undefined;
  isCompetitionDrop?: boolean | undefined;
  mediaImageScale?: ImageScale | undefined;
  mediaContainerHeightClassName?: string | undefined;
  fullWidthMedia?: boolean | undefined;
  fullWidthLinkPreviews?: boolean | undefined;
  readonly onLinkCardActionsActiveChange?: ((href: string, active: boolean) => void) | undefined;
  readonly contentPresentation?: DropContentPresentation | undefined;
  readonly embedPath?: readonly string[] | undefined;
  readonly quotePath?: readonly string[] | undefined;
  readonly embedDepth?: number | undefined;
  readonly maxEmbedDepth?: number | undefined;
}
const WaveDropPartDrop: React.FC<WaveDropPartDropProps> = t0 => {
  const $ = _c(30);
  const {
    drop,
    activePart,
    havePreviousPart,
    haveNextPart,
    isStorm,
    activePartIndex,
    setActivePartIndex,
    onQuoteClick,
    isEditing: t1,
    isSaving: t2,
    onSave,
    onCancel,
    isCompetitionDrop: t3,
    mediaImageScale: t4,
    mediaContainerHeightClassName,
    fullWidthMedia: t5,
    fullWidthLinkPreviews: t6,
    onLinkCardActionsActiveChange,
    contentPresentation: t7,
    embedPath,
    quotePath,
    embedDepth,
    maxEmbedDepth
  } = t0;
  const isEditing = t1 === undefined ? false : t1;
  const isSaving = t2 === undefined ? false : t2;
  const isCompetitionDrop = t3 === undefined ? false : t3;
  const mediaImageScale = t4 === undefined ? ImageScale.AUTOx450 : t4;
  const fullWidthMedia = t5 === undefined ? false : t5;
  const fullWidthLinkPreviews = t6 === undefined ? false : t6;
  const contentPresentation = t7 === undefined ? "default" : t7;
  const showStandaloneTitle = contentPresentation !== "quorumCompact";
  let t8;
  if ($[0] !== drop.title || $[1] !== showStandaloneTitle) {
    t8 = showStandaloneTitle && <WaveDropPartTitle title={drop.title} />;
    $[0] = drop.title;
    $[1] = showStandaloneTitle;
    $[2] = t8;
  } else {
    t8 = $[2];
  }
  let t9;
  if ($[3] !== activePart || $[4] !== activePartIndex || $[5] !== contentPresentation || $[6] !== drop || $[7] !== embedDepth || $[8] !== embedPath || $[9] !== fullWidthLinkPreviews || $[10] !== fullWidthMedia || $[11] !== haveNextPart || $[12] !== havePreviousPart || $[13] !== isCompetitionDrop || $[14] !== isEditing || $[15] !== isSaving || $[16] !== isStorm || $[17] !== maxEmbedDepth || $[18] !== mediaContainerHeightClassName || $[19] !== mediaImageScale || $[20] !== onCancel || $[21] !== onLinkCardActionsActiveChange || $[22] !== onQuoteClick || $[23] !== onSave || $[24] !== quotePath || $[25] !== setActivePartIndex) {
    t9 = <WaveDropPartContent mentionedUsers={drop.mentioned_users} mentionedGroups={drop.mentioned_groups} mentionedWaves={drop.mentioned_waves} referencedNfts={drop.referenced_nfts} wave={drop.wave} activePart={activePart} havePreviousPart={havePreviousPart} haveNextPart={haveNextPart} isStorm={isStorm} activePartIndex={activePartIndex} setActivePartIndex={setActivePartIndex} onQuoteClick={onQuoteClick} isEditing={isEditing} isSaving={isSaving} onSave={onSave} onCancel={onCancel} drop={drop} isCompetitionDrop={isCompetitionDrop} mediaImageScale={mediaImageScale} mediaContainerHeightClassName={mediaContainerHeightClassName} fullWidthMedia={fullWidthMedia} fullWidthLinkPreviews={fullWidthLinkPreviews} onLinkCardActionsActiveChange={onLinkCardActionsActiveChange} contentPresentation={contentPresentation} embedPath={embedPath} quotePath={quotePath} embedDepth={embedDepth} maxEmbedDepth={maxEmbedDepth} />;
    $[3] = activePart;
    $[4] = activePartIndex;
    $[5] = contentPresentation;
    $[6] = drop;
    $[7] = embedDepth;
    $[8] = embedPath;
    $[9] = fullWidthLinkPreviews;
    $[10] = fullWidthMedia;
    $[11] = haveNextPart;
    $[12] = havePreviousPart;
    $[13] = isCompetitionDrop;
    $[14] = isEditing;
    $[15] = isSaving;
    $[16] = isStorm;
    $[17] = maxEmbedDepth;
    $[18] = mediaContainerHeightClassName;
    $[19] = mediaImageScale;
    $[20] = onCancel;
    $[21] = onLinkCardActionsActiveChange;
    $[22] = onQuoteClick;
    $[23] = onSave;
    $[24] = quotePath;
    $[25] = setActivePartIndex;
    $[26] = t9;
  } else {
    t9 = $[26];
  }
  let t10;
  if ($[27] !== t8 || $[28] !== t9) {
    t10 = <div className="tw-relative tw-flex tw-h-full tw-gap-x-3"><div className="tw-flex tw-h-full tw-w-full tw-flex-col tw-self-center sm:tw-self-start"><div>{t8}{t9}</div></div></div>;
    $[27] = t8;
    $[28] = t9;
    $[29] = t10;
  } else {
    t10 = $[29];
  }
  return t10;
};
export default WaveDropPartDrop;